// Clave de sessionStorage compartida entre destination-big/destination-small (que la escriben
// en articleRedirect()) y usb-article (que la lee para armar el header hero). sessionStorage se
// usa en vez de router state porque sobrevive a un refresh de la página del artículo.
export const HEADER_ORIGIN_STORAGE_KEY = 'articleHeaderOrigin';

export interface ArticleHeaderOrigin {
  typeArticle: string;
  id: number;
  image: string;
  title: string;
  description: string;
}
